export default function SectionIntro({
    eyebrow,
    title,
    description,
    align = 'left',
    width = 'default',
}) {
    const introClasses = [
        'section-intro',
        align === 'center' ? 'section-intro--center' : '',
        width === 'wide' ? 'section-intro--wide' : '',
    ]
        .filter(Boolean)
        .join(' ')

    return (
        <div className={introClasses}>
            {eyebrow ? (
                <div className="mb-[10px]">
                    <span className="meta-pill section-caption">{eyebrow}</span>
                </div>
            ) : null}
            {title ? <h2 className="mb-8 section-title">{title}</h2> : null}
            {description ? (
                <p className="section-descr body-copy mb-0">{description}</p>
            ) : null}
        </div>
    )
}
